import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { useRef } from 'react';
import AnimatedElement from '../..';
import { ObjectPropsPropType } from '../../../../../../services/proptypes';
import { classNames } from '../../../../../../utils/classname';
import { ANIMATION_STATUS, DEFAULT_ANIMATION_DURATION } from '../../../../animation.constants';
import useFixedValueAnimation from '../../../../hooks/use-fixed-value-animation';
import { HEIGHT_TRANSITION } from '../../../../types/animation.types';
import './AnimateHeight.css';
var defaultProps = {
  duration: DEFAULT_ANIMATION_DURATION,
  easing: 'ease',
  height: 'auto',
  className: '',
  style: {}
};
var PRE_ANIMATING = ANIMATION_STATUS.PRE_ANIMATING,
  ANIMATING = ANIMATION_STATUS.ANIMATING,
  NO_ANIMATION = ANIMATION_STATUS.NO_ANIMATION;
export default function AnimateHeight(_ref) {
  var _ref2;
  var children = _ref.children,
    className = _ref.className,
    style = _ref.style,
    duration = _ref.duration,
    easing = _ref.easing,
    height = _ref.height;
  var contentRef = useRef(null);
  var _useFixedValueAnimati = useFixedValueAnimation(height, contentRef, HEIGHT_TRANSITION, {
      duration: duration
    }),
    currentHeight = _useFixedValueAnimati.currentValue,
    overflow = _useFixedValueAnimati.overflow,
    state = _useFixedValueAnimati.state;
  var status = state.status;
  return /*#__PURE__*/React.createElement(AnimatedElement, {
    status: status,
    transitionType: HEIGHT_TRANSITION,
    transitionProps: (_ref2 = {}, _defineProperty(_ref2, PRE_ANIMATING, {
      height: currentHeight,
      overflow: overflow
    }), _defineProperty(_ref2, ANIMATING, {
      height: currentHeight,
      overflow: overflow
    }), _defineProperty(_ref2, NO_ANIMATION, {
      height: currentHeight,
      overflow: style.overflow || overflow
    }), _ref2),
    duration: duration,
    easing: easing,
    wrap: true,
    className: classNames(_defineProperty({
      'animate-height': true
    }, className, true))
  }, /*#__PURE__*/React.createElement("div", {
    ref: contentRef
  }, children));
}
AnimateHeight.defaultProps = defaultProps;